<template>
  <div class="container">
    <el-row :gutter="10" class="button-wrapper">
     <el-col :span="6"><el-button type="primary" size="mini" @click="$router.go(-1)">返回训练任务列表</el-button></el-col>
    </el-row>
    <h3 class="header1">数据来源: <el-badge class="mark" :value="imageList.length">
      <el-tag type="success">检测总数 </el-tag></el-badge>
      <el-badge class="mark" :value="dif_list.length">
      <el-tag type="danger">错误总数 </el-tag></el-badge>
      <el-button type="text" v-if="summaryShow === true" @click="summaryShow = false">查看图片归属</el-button>
      <span v-else>
        <el-button type="text" @click="showDif = !showDif">{{showDif ? '查看详细信息' :
          "查看错误信息"}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button type="text"  @click="summaryShow = true">查看统计信息</el-button>
      </span>
    </h3>
    <el-row :gutter="10" class="chart-wrapper" v-if="summaryShow">
      <!--<el-col :span="6">10</el-col>-->
      <el-col :span="14">
        <checkResultChart class="chart-item" :series="dish_acc_list_reverse"></checkResultChart>
      </el-col>
      <el-col :span="10">
        <el-table
          :data="dish_acc_list"
          height="80vh"
          style="width: 100%">
          <el-table-column
            align="center"
            header-align="center"
            prop="dish_name"
            label="碗碟名称"
            width="180">
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="name"
            label="例图"
            width="180">
            <template slot-scope="scope">
              <div class="image-wrapper">
                <img :src="scope.row.dish_url" class="image-item" alt="">
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="errorCount"
            label="错误总数">
          </el-table-column>
          <el-table-column
          align="center"
          header-align="center"
          prop="count"
          label="总数">
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="dish_acc"
            label="准确率">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :gutter="10" v-else>
      <el-card class="box-card" v-for="name in keyOfImgListGroupBy" :key="name">
       <div slot="header" class="clearfix">
         <h4 class="header-title">所属例图：{{name}} <el-badge class="mark" :value="displayList[name] ?
         displayList[name].length : 0"/></h4>
         <div class="image-item-wrapper">
          <img :src="imgListGroupBy[name][0].dish_url" alt="" width="50" height="50" class="image-item">
         </div>
       </div>
       <div class="">
         <div class="image-item-wrapper" v-for='dish in displayList[name] ? displayList[name] : []' width="50"
              height="50"
              :key="dish.img_url">
           <img :src="dish.img_url" v-lazy="dish.img_url" alt="" class="image-item">
         </div>
       </div>
     </el-card>
    </el-row>
    <el-row :gutter="10">
    </el-row>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

import checkResultChart from './checkResultChart';

export default {
  name: '',
  components: {
    checkResultChart
  },
  data () {
    return {
      showDif: true,
      summaryShow: true
    };
  },
  mounted () {
    this.setSubTitle('模型检测结果');
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    viewDetail () {
      this.$router.push('checkResultDetail');
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters([]),
    imageList () {
      if (this.$route.params && this.$route.params.img_info_list) {
        return this.$route.params.img_info_list;
      } else {
        return [];
      }
    },
    dish_acc_list() {
      let dish_acc_list = this.$route.params.dish_acc_list;
      dish_acc_list.forEach(a => {
        let count = this.imgListGroupBy[a.dish_name] ? this.imgListGroupBy[a.dish_name].length : 0;
        this.$set(a, 'count', count);
        this.$set(a, 'errorCount', count - count * a.dish_acc);
      });
      dish_acc_list.sort((a, b) => a.dish_acc - b.dish_acc);
      return dish_acc_list;
    },
    dish_acc_list_reverse () {
      let _dish_acc_list = this.$_.cloneDeep(this.dish_acc_list);
      return _dish_acc_list.sort((a, b) => -a.dish_acc + b.dish_acc);
    },
    dif_list () {
      return this.$route.params.dif_img_info_list;
    },
    dif_img_info_list () {
      let dif_img_info_list = this.dif_list;
      return this.$_.groupBy(dif_img_info_list, 'dish_name');
    },
    modelList () {
      return this.$router.params.classList;
    },
    imgListGroupBy () {
      let imageList = this.imageList;
      // let obj = {};
      // imageList.forEach((a, idx) => {
      //   if (!a.dish_name) {
      //     // console.log(a.dish_url.match(/[^/]+(?!.*])/g)[-1]);
      //     console.log(a);
      //     a.dish_name = `暂无名称-${idx}`;
      //   }
      //   if (obj.hasOwnProperty(a.dish_name)) {
      //     // this.$set(obj, a.dish_name, a)
      //     obj[a.dish_name].push(a);
      //   } else {
      //     this.$set(obj, a.dish_name, []);
      //     obj[a.dish_name].push(a);
      //   }
      // });
      let obj = this.$_.groupBy(this.imageList, 'dish_name');
      // let keys = Object.keys(obj);
      // keys.forEach(a => {
      //   let dif_list = [];
      //   if (this.dif_img_info_list.hasOwnProperty(a)) {
      //     dif_list = this.dif_img_info_list[a];
      //   }
      //   this.$set(a, 'dif_list', dif_list);
      // });
      return obj;
    },
    keyOfImgListGroupBy () {
      return Object.keys(this.imgListGroupBy);
    },
    computedCount  () {
      let vs = Object.values(this.imgListGroupBy);
      // let counts =  this.imageList.map((a) => {
      //   // return a.
      // });
      // return vs;
      let list = vs.map(a => {
        return {
          dish_image_url: a[0].dish_url,
          dish_name: a[0].dish_name,
          count: a.length || 0
        };
      });
      list.sort((a, b) => { return b.count - a.count; });
      return list;
    },
    displayList () {
      if (this.showDif) {
        return this.dif_img_info_list;
      }
      return this.imgListGroupBy;
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
	position: relative;
	height: 90vh;
	overflow-y: scroll;
	overflow-x: hidden;
  .header1 {
    padding: 10px;
  }
  .chart-wrapper {
    .chart-item {
      width: 50vw;
      height: 400px;
    }
  }
	.button-wrapper {
		position: fixed;
		left: 400px;
		top: 15px;
		z-index: 100;
	}
	.header-title {
		display: inline-block;
		vertical-align: middle;
	}
	.image-item-wrapper {
		vertical-align: middle;
		display: inline-block;
		width: 50px;
		height: 50px;
		.image-item {
			width: auto;
			height: auto;
			max-height: 100%;
			max-width: 100%;
		}
	}
  .image-wrapper {
    display: inline-block;
    width: 50px;
    height: 50px;
    .image-item {
      width: auto;
      height: auto;
      max-width: 100%;
      max-width: 100%;
      &[lazy=error] {
        /*your style here*/
        width: 100%;
        height: 100%;
        background-color: rgba(239, 239, 239, 1);
      }
      &[lazy=loading] {
        /*your style here*/
        width: 100%;
        height: 100%;
        background-color: rgba(239, 239, 239, 1);
      }
    }
  }
}
</style>
